<template>
<div>
  <v-snackbar
      v-model="showToast"
      :timeout="timeout"
      :color="color"
      :outlined="outlined"
      top
      right
      shaped
      elevation="12"
      >
      <div class="d-flex align-center justify-space-between">
        <div>
          <v-icon small>{{icon}}</v-icon>
          <span class="body-2 pl-3">{{$t(text)}}</span>
        </div>
        <div class="d-flex">
          <a :href="link" v-if="link" target="_blank">
            <v-btn color="primary lighten-5" text  class="font-weight-bold mx-2">{{$t('general.go')}}</v-btn>
          </a>
          <v-icon small @click="onCloseClick()">close</v-icon>
        </div>
      </div>
  </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'Toaster',
    data() {
      return {
        showToast : false,
        color: "primary",
        outlined: true,
        timeout: 8500,
        text: "",
        icon: "",
        link: ""
      }
    },
    watch: {
      "$store.state.toaster.toast": function(newToast, oldToast) {
        this.showToast = _.get(newToast,'showToast',this.showToast); 
        this.color = _.get(newToast,'color',this.color);
        this.outlined = _.get(newToast,'outlined',this.outlined);
        this.text = _.get(newToast,'text');
        // this.timeout = _.get(newToast,'timeout',this.timeout);
        this.icon = _.get(newToast,'icon'); 
        this.link = _.get(newToast,'link'); 
      }
    },
    methods:{
      onCloseClick(){
        this.showToast = false;
      }
    }
  }
</script>

<style>
</style>
